import { GLYPH_OWN_SIZE } from 'components/buttons/buttonStyle';
import { ChevronLeft as ChevronLeftIcon } from 'components/icons';
import { Button } from 'components/ui/button';
import { useCallback, useState } from 'react';
import { InvoiceData } from 'types/invoices';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import SummarySidebar from './SummarySidebar';

interface Props {
    invoice: InvoiceData;
    isLoading: boolean;
    templateValidation: () => Promise<boolean>;
}

const SummaryDrawer = ({ invoice, isLoading, templateValidation }: Props) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleDrawer = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    return (
        <div
            className={cn(
                'border-divider relative border-x transition-[width,padding] duration-[400ms] ease-in-out',
                isOpen ? 'w-[312px] px-0 @max-[1186px]/invoice:w-[280px] @max-[1012px]/invoice:w-[240px]' : 'w-0 px-3'
            )}
        >
            <Button
                variant="ghost"
                size="icon-sm"
                onClick={toggleDrawer}
                aria-label={t('invoices.summary-sidebar.title')}
                className={cn(
                    GLYPH_OWN_SIZE,
                    'bg-paper hover:bg-paper shadow-card text-grey-500 absolute top-2 left-0 size-[30px] -translate-x-1/2 rounded-full'
                )}
            >
                <ChevronLeftIcon
                    className={cn('transition-transform duration-[400ms] ease-in-out', isOpen && 'rotate-180')}
                />
            </Button>
            <div
                className={cn(
                    'size-full overflow-auto transition-[visibility,opacity,padding] duration-[400ms] ease-in-out',
                    isOpen
                        ? 'visible px-6 py-5 opacity-100 @max-[1186px]/invoice:px-4 @max-[1186px]/invoice:py-1 @max-[1012px]/invoice:px-3'
                        : 'invisible px-3 py-5 opacity-0 @max-[1186px]/invoice:px-1 @max-[1186px]/invoice:py-1 @max-[1012px]/invoice:px-1'
                )}
            >
                <SummarySidebar invoice={invoice} isLoading={isLoading} templateValidation={templateValidation} />
            </div>
        </div>
    );
};

export default SummaryDrawer;
